/**
 * Which ad a shared board shows. Each time the board comes up on the road it moves on to the next ad
 * (starting at a random one, so a short shift doesn't always see the first), and if you sit in front of
 * it (a red light, a stop) it moves on every HOLD_SECONDS. Every ad gets its fair turn.
 */
export const HOLD_SECONDS = 10;

export interface Rotation {
  turn: number;
  shownFor: number;
  inRange: boolean;
}

export function newRotation(random: () => number = Math.random): Rotation {
  return { turn: Math.floor(random() * 1000), shownFor: 0, inRange: false };
}

/** Advances the rotation for one frame and returns the index of the ad to show (0 when there's one). */
export function rotate(r: Rotation, inRange: boolean, dt: number, count: number): number {
  if (inRange && !r.inRange) {
    r.turn += 1;
    r.shownFor = 0;
  } else if (inRange) {
    r.shownFor += dt;
    if (r.shownFor >= HOLD_SECONDS) {
      r.turn += 1;
      r.shownFor = 0;
    }
  }
  r.inRange = inRange;
  return count > 0 ? r.turn % count : 0;
}
